class SopPushType {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'SopPushType'

export const EMAIL = new SopPushType(0, 'email', '邮件')
export const NOTE = new SopPushType(1, 'note', '短信')

export const SOP_PUSH_TYPE = [EMAIL, NOTE]
